import { newToolFilterOAuthMcp } from "../oauth.ts";

export const mercuryMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://mercury.com/icon.svg",
  url: "https://mcp.mercury.com/mcp",
  label: "Mercury",
});
